import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { ListResultsSearch } from 'widgets/avia/search-result-avia'

import { useGetSearchParams } from 'features/libs/get-search-params/getSearchParams'

import findTicketStore from 'entities/ticket/models/find-ticket/find-ticket-store'

const ListResultsSearchPageWidget = observer(() => {
  const dynamicDirection = useGetSearchParams()

  const formSearchTicket = toJS(findTicketStore.formFindTicket)

  const navigate = useNavigate()

  const paramsSearch = () => {
    if (dynamicDirection) {
      formSearchTicket.directions = [dynamicDirection]

      findTicketStore.setFirstForm(dynamicDirection)
    } else {
      navigate(RoutingPaths.path())
    }
  }

  useEffect(() => paramsSearch(), [])

  return <ListResultsSearch formSearchAvia={formSearchTicket} />
})

export default ListResultsSearchPageWidget
